import { useNavigate } from "react-router-dom";
import { Card, Row, Col, Typography, Tag } from "antd";
import { RightOutlined } from "@ant-design/icons";
import ModuleHeader from "../../components/ModuleHeader";
import { getSectionList } from "./sectionConfigs";
import "./Settings.css";

const { Text } = Typography;

export default function Settings() {
  const navigate = useNavigate();
  const sections = getSectionList();

  const handleSectionClick = (section) => {
    if (section.disabled) return;
    navigate(`/settings/${section.key}`);
  };

  return (
    <div>
      <ModuleHeader title="Settings" />

      <div style={{ padding: "0 24px" }}>
        <Row gutter={[16, 16]}>
          {sections.map((section) => (
            <Col xs={24} sm={12} md={8} lg={6} key={section.key}>
              <Card
                hoverable={!section.disabled}
                className={`settings-card ${section.disabled ? "settings-card-disabled" : ""}`}
                onClick={() => handleSectionClick(section)}
              >
                <div className="settings-card-content">
                  <div>
                    <Text strong className="settings-card-title">
                      {section.label}
                    </Text>
                    <Text type="secondary" className="settings-card-desc">
                      {section.description}
                    </Text>
                  </div>
                  <div className="settings-card-footer">
                    {section.disabled ? (
                      <Tag color="default">Coming Soon</Tag>
                    ) : (
                      <RightOutlined className="settings-card-arrow" />
                    )}
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}
